var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSnagitLogo24X24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SnagitLogo24x24_svg__a)",
  d: "M21.75 0H2.25A2.25 2.25 0 0 0 0 2.25v19.5A2.25 2.25 0 0 0 2.25 24h19.5A2.25 2.25 0 0 0 24 21.75V2.25A2.25 2.25 0 0 0 21.75 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.983 2.86a.37.37 0 0 1 .268-.11h11.132a.36.36 0 0 1 .267.116.4.4 0 0 1 .1.251.37.37 0 0 1-.108.252l-3.29 3.018a.37.37 0 0 1-.25.113H4.5zm.224 14.39a.36.36 0 0 0-.25.103l-3.35 3.024a.37.37 0 0 0-.107.253.4.4 0 0 0 .1.252c.069.076.166.119.268.118h11.13a.37.37 0 0 0 .25-.11l3.502-3.64zM4.5 10h11.517a.36.36 0 0 1 .25.11l3.483 3.64H8.233a.36.36 0 0 1-.25-.11z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 13.75h3.75v3.5H16zM4.5 6.5h3.75V10H4.5z",
  opacity: 0.74
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SnagitLogo24x24_svg__a",
  x1: 12,
  x2: 12,
  y1: 0,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5CA7DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3879BD"
})))));
export default SvgSnagitLogo24X24;